var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtremely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0.421875C17.8137 0.421875 20.5 3.10817 20.5 6.42188V14.4219C20.5 17.7356 17.8137 20.4219 14.5 20.4219H6.5C3.18629 20.4219 0.5 17.7356 0.5 14.4219V6.42188C0.5 3.10817 3.18629 0.421875 6.5 0.421875H14.5ZM14.1416 11.8213C12.1304 13.8321 8.86945 13.8323 6.8584 11.8213L5.65723 13.0234C8.33221 15.6979 12.6688 15.6979 15.3438 13.0234L14.1416 11.8213ZM5.25 8.37207L6.2998 9.42188L7.40039 8.37207L8.4502 9.42188L9.5 8.37207L7.40039 6.22168L5.25 8.37207ZM11.5 8.37207L12.5498 9.42188L13.5996 8.37207L14.7002 9.42188L15.75 8.37207L13.5996 6.22168L11.5 8.37207Z",
    fill: "#09C25A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtremely);
export default __webpack_public_path__ + "static/media/extremely.b44386e05991fcef5d66b069bef02164.svg";
export { ForwardRef as ReactComponent };